export interface IWithUnsplashClickAnalyticsOuter {}

export interface IWithUnsplashClickAnalyticsInner {
  trackUnsplashLinkClickClicked: (target: UnsplashTarget, clickOrigin: UnsplashClickOrigin) => void;
}

export enum UnsplashTarget {
  Terms = 'terms',
  LearnMore = 'learn_more',
  DesignerName = 'designer_name',
}

export enum UnsplashClickOrigin {
  UnsplashTab = 'unsplash_tab',
  Preview = 'preview',
}
